import OwButton from "@components/shared/OwButton/OwButton";
import { OrderPaymentAuthorizeNetNewCard } from "../OrderPaymentAuthorizeNetNewCard/OrderPaymentAuthorizeNetNewCard";
import React, { useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import { OrderPaymentAuthorizeNetExistingCard } from "../OrderPaymentAuthorizeNetExistingCard/OrderPaymentAuthorizeNetExistingCard";
import IOrder from "@models/IOrder";
import OwTitle from "@components/shared/OwTitle/OwTitle";

type Props = {
    orderModel: IOrder;
};

export const OrderPaymentAuthorizeNetPaymentSelection = (props: Props) => {
    const [existingCard, setExistingCard] = useState<any>(null);

    const showNewCardComponent = () => {
        setExistingCard(null);
    }

    const showExistingCardComponent = () => {
        setExistingCard(true);
    }


    return <div className={"OrderPaymentAuthorizeNetPaymentSelection"}>
        <div className="text-center mt-2 mb-2">
            <ButtonGroup>
                <OwButton className={`btn-primary ${existingCard ? "" : "active"}`} title="new_card" fn={showNewCardComponent}/>
                {/* <OwButton className={`btn-primary ${existingCard ? "active" : ""}`} title="existing_card" fn={showExistingCardComponent}/> */}
            </ButtonGroup>
        </div>

        <OwTitle title="payment_selection" tag="h3"/>

        {existingCard ?
        <OrderPaymentAuthorizeNetExistingCard orderModel={props.orderModel}/> :
        <OrderPaymentAuthorizeNetNewCard orderModel={props.orderModel}/>}
    </div>;
};
